import { createSlice } from "@reduxjs/toolkit";

const countrySlice = createSlice({
  name: "countryCode",
  initialState: "US",
  reducers: {
    setCountry(state = "", action) {
      return action.payload || state;
    },
  },
});

export const { setCountry } = countrySlice.actions;

export default countrySlice.reducer;
